// @ts-nocheck
import { Link } from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useEffect, useState, useCallback } from "react";
import { useInfiniteHits, useSearchBox } from "react-instantsearch-hooks-web";
import { useHistory } from "react-router-dom";
import algoliasearch from "algoliasearch/lite";
import styled from "styled-components";
import levenshtein from "fast-levenshtein";
import { openProductPage } from "utils/product";
import { searchClientIndex } from "App";
import { log } from "console";

export default function OfferComponent(props: any) {
  const history = useHistory();
  const [stationaryItem, setStationaryItems] = useState<any>([]);

  const isSimilar = (s1: string, s2: string) => {
    const maxLength = Math.max(s1.length, s2.length);
    const distance = levenshtein.get(s1, s2);
    const similarity = ((maxLength - distance) / maxLength) * 100;

    return similarity > 90;
  };

  const filterSearchItems = (hits: any) => {
    return hits.filter((item: any, index: number, self: any) => {
      const similarIndex = self.findIndex((otherItem: any) => {
        const similar = isSimilar(item.title, otherItem.title);
        return similar;
      });
      const keep = index === similarIndex;
      return keep;
    });
  };

  useEffect(() => {
    searchClientIndex
      .search(props.data.category as string, { hitsPerPage: 100 })
      .then(({ hits }) => {
        const filteredHits = filterSearchItems(hits);

        setStationaryItems(filteredHits);
      });
  }, [props.data.category]);

  const salePrice = (item: any) => {
    if (
      item.saleprice[0] &&
      item.price[0] &&
      item.saleprice[0] !== item.price[0]
    ) {
      const price = Math.min(item.saleprice[0], item.price[0]);
      const prevPrice = Math.max(item.saleprice[0], item.price[0]);
      const discount = ((prevPrice - price) / prevPrice) * 100;

      // check if
      const showDiscountSignGreaterThan5 = discount > 5;
      const showDiscountSignGreaterThan1 = (discount) => 1;

      return (
        <div>
          {showDiscountSignGreaterThan5 && (
            <>
              <DiscountBox>{Number(discount).toFixed(2)}% off</DiscountBox>
            </>
          )}
          <Price>${Number(price).toFixed(2)}</Price>
          <PrevPrice>${Number(prevPrice).toFixed(2)}</PrevPrice>
        </div>
      );
    }

    return <Price>${Number(item.price[0]).toFixed(2)}</Price>;
  };

  return (
    <Wrapper>
      <FluidContainer>
        <section className="valentine-section ">
          <Header>{props.data.heading}</Header>
          <Header>{props.data.subHeading}</Header>
          <HeaderDivider />
          <div>
            <ProductList>
              {stationaryItem &&
                stationaryItem.length > 0 &&
                stationaryItem
                  // ?.filter(    // need to  uncomment after record added to algolia
                  //   (item: any) =>
                  //     item?.Quantity !== undefined &&
                  //     item?.Quantity>0
                  // )
                  .slice(0, 5)
                  .map((item: any, index: number) => {
                    return (
                      <li
                        key={item.toString()}
                        onClick={() => {
                            const { id, title } = item;
                            openProductPage(id, title);
                          }
                        }
                        style={{}}
                      >
                        <ProductCard>
                          <ProductImg>
                            <Link>
                              <Image
                                alt={item.title}
                                src={item.productgroupimageurl1}
                              />
                            </Link>
                          </ProductImg>
                          <ProductDetails>
                            <ProductName>{item.title}</ProductName>
                            {salePrice(item)}
                          </ProductDetails>
                        </ProductCard>
                      </li>
                    );
                  })}
            </ProductList>
          </div>
        </section>
      </FluidContainer>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  margin: 1rem 2rem;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.3);
  border-radius: 12px; /* Adjusted border radius for the entire container */
  overflow: hidden; /* Prevents child elements from overflowing */
  @media (max-width: 430px) {
    margin: 0rem 0.5rem;
  }
`;

const FluidContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 2rem;
  background: white;
`;

const ProductList = styled.ul`
  display: grid;
  justify-content: center;
  align-items: stretch;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  margin-top: 1rem;
  @media (max-width: 430px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ProductCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
  /* align-items: center; */
`;

const ProductImg = styled.div`
  height: 230px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 600ms ease-in-out;
  cursor: pointer;

  &::before {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    content: "";
    display: none;
  }

  &:hover {
    &::before {
      display: block;
      background: rgba(0, 0, 0, 0.28);
    }
  }
`;

const ProductDetails = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const Header = styled.h4`
  width: fit-content;
  font-size: 1.25rem;
  margin: 0 !important;
  text-transform: uppercase;
`;

const Price = styled.p`
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
  color: black;
  position: relative;
`;

const PrevPrice = styled.p`
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 500;
  color: grey;
  position: relative;
  text-decoration: line-through;
  margin-left: 0.5rem;
  margin-top: 0.5rem;
`;

const ProductName = styled.p`
  font-weight: 400;
  font-size: 0.85rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-bottom: 0.25rem;
`;

const DiscountBox = styled.div`
  background-color: #cc0c39;
  color: #ffffff;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 0.9rem;
  max-width: fit-content;
`;

const HeaderDivider = styled.hr`
  margin-top: -0.05px;
  margin-bottom: 30px;
`;

const Tag = styled.div`
  display: flex;
  align-items: center;
  color: #cc0c39;
  position: absolute;
  top: 8px;
  right: 8px;
  border-radius: 8px;
  font-size: 10px; /* Adjusted font size for the red tag */
  line-height: 1;
  padding: 2px 6px; /* Adjusted padding for the red tag */
  font-weight: 600;
  background-color: #ffffff;
  border: 1px solid #cc0c39;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-right: 4px; /* Added margin for space between icon and text */
`;

const SalesText = styled.span`
  font-size: 12px; /* Adjusted font size for the "Sales" text */
  margin-left: 4px; /* Added margin between the red tag and "Sales" text */
`;
